import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { SharedService } from 'src/app/shared/services';
import { IUpdateThemeColsAssignList, SearchPageColumns } from '../../models';
import { SearchThemeColumnsAssignService } from '../../services';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-themecolumns-assign',
  templateUrl: './search-themecolumns-assign.component.html',
  styleUrls: ['./search-themecolumns-assign.component.css'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class SearchThemecolumnsAssignComponent implements OnInit {
  availableColumns: any[] = [];
  selectedColumns: any[] = [];
  draggedColumns: SearchPageColumns;
  searchPageNamesList:ILookupCategory;
  searchPageNameLkId: any;
  searchPageThemesList:any;
  searchThemeId:any;
  pageSelected:boolean = false;
  themeSelected:boolean = false;
  showThemeColAssign:boolean = false;
  loadingSaveButton:boolean = false;
  saveEnable:boolean = false;
  constructor(
    private searchThemeColumnsAssignService:SearchThemeColumnsAssignService,
    public sharedService: SharedService,
    private spinner:NgxSpinnerService,
    private messageService: MessageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    //this.getSearchPageColumns();
    this.getSearchPageNames();
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this.router.navigateByUrl('/login');
  }
  // dragToSelectedColumns(column) {
  //   this.draggedColumns = column;
  // }
  // dragToAllColumns(column) {
  //   this.draggedColumns = column;
  // }

  // dropToSelectedColumns() {
  //   if (this.draggedColumns) {
  //     this.selectedColumns = [...this.selectedColumns, this.draggedColumns];
  //     this.availableColumns = this.availableColumns.filter(item => item.columnId !== this.draggedColumns.columnId);
  //     this.draggedColumns = null;
  //     this.saveEnable = true;
  //   }
  // }
  // dropToAllColumns() {
  //   if (this.draggedColumns) {
  //     this.availableColumns = [...this.availableColumns, this.draggedColumns];
  //     this.selectedColumns =this.selectedColumns.filter(item => item.columnId !== this.draggedColumns.columnId);      this.draggedColumns = null;
  //     this.draggedColumns = null;
  //     this.saveEnable = true;
  //   }
  // }

  // dragEndSelectedColumns() {
  //   this.draggedColumns = null;
  // }

  // dragEndAllColumns() {
  //   this.draggedColumns = null;
  // }

  getSearchPageColumns() {
    var invoicepage = 1;
    this.searchThemeColumnsAssignService.getSearchPageColumns(invoicepage).subscribe((data: any) => {
      this.availableColumns = data;
      console.log(data);
    });
  }

  getSearchPageNames() {
    //this.categoryName = 'Search Page Names';
      this.sharedService.getLookupMasterByCategoryId(LookupCategory.SearchPageNames).subscribe((data: any) => {
      this.searchPageNamesList = data;
      console.log(data);
      
    });
  }

  getSearchPageNameOnChange(event) {
    this.searchPageNameLkId = event.value;
    this.pageSelected = true;
    this.themeSelected = false;
    this.getThemeNames();
  }

  getThemeNames() 
  {
    this.searchThemeColumnsAssignService.getThemeNames(this.searchPageNameLkId).subscribe((data: any) => {
      this.searchPageThemesList = data;
    });
  }

  getSearchThemeNameOnChange(event)
  {
    this.searchThemeId= event.value;
    this.themeSelected = true;
  }
  
  search()
  {
    this.showThemeColAssign = true;
    this.spinner.show();
    this.searchThemeColumnsAssignService.getThemeColsAssignList(this.searchPageNameLkId,this.searchThemeId).subscribe((data: any) => {
      this.selectedColumns = data[0].assignedColumnList;
      this.availableColumns =data[0].notAssignedColumnsList;
      this.saveEnable= true;
      this.spinner.hide();
    }); 
  }

  saveThemeColumnsAssign()
  {
    this.spinner.show();
    this.loadingSaveButton = true;
    const themeColAssignUpdate: IUpdateThemeColsAssignList = {
      themeId:this.searchThemeId,
      searchPageNameLkId:this.searchPageNameLkId,
      selectedColumns:this.selectedColumns,
    }
    console.log(themeColAssignUpdate);
    this.searchThemeColumnsAssignService.updateThemeColsAssignList(themeColAssignUpdate).subscribe((data: any) => {
      this.loadingSaveButton = false;
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Columns added to theme' });
      this.search();
    });
  }

}
